import React from 'react';
import NavBar from '../components/layout/navbar';
import './home.css';
import heroMoon from '../assets/imgs/heroMoon.png';
import collage1 from '../assets/imgs/collage1.png';
import ScrollHorizontal from '../components/layout/life';
import Footer from '../components/layout/footer';
import { useEffect } from 'react';
import { useState } from 'react';
import Preloader from '../components/layout/preloader';
import collage2 from '../assets/imgs/collage2.png';
import book1 from '../assets/imgs/book1.png';
import book2 from '../assets/imgs/book2.png';
import book3 from '../assets/imgs/book3.png';
import SectionTitle from '../components/common/sectionTitle';
import collage3 from '../assets/imgs/collage3.png';
import Theme from '../components/common/theme';



const Home = () => {
    const [loading, setLoading] = useState(true)

    useEffect(() => {
      const timer = setTimeout(() => {
        setLoading(false)
      }, 2000)
  
      return () => clearTimeout(timer)
    }, [])
  
    if (loading) {
      return <Preloader />
    }

    return ( 
        <>
        <NavBar />
            <div className="bg"></div>
        <main>
            <section id='hero'>
                <img className='collage1' src={collage1} alt="edgar allan poe collage that includes a raven and a hand covering his face and highlighting his eyes" />
                <h1 className='heroText'>I became <span className='highlight'>insane,</span> <br/> with long intervals of horrible sanity.</h1>
                <img className='heroMoon' src={heroMoon} alt="moon" />
            </section>
            <h2 className='author'>Edgar Allan Poe</h2>
            <section id='life'>
                <ScrollHorizontal />
            </section>
            <section id='works'>
                <SectionTitle secTitle="Famous Works" />
                <div className="worksCont">
                    <div className="books">
                        <img className='book' src={book1} alt="" />
                        <img className='book10' src={book2} alt="" />
                        <img className='book' src={book3} alt="" />
                    </div>
                    <img src={collage2} alt="" />
                </div>
            </section>
            <section id='themes'>
                <SectionTitle secTitle="Inside Poe’s Dark Imagination" />
                <div className="themesCont">
                    <div className="themesContent">
                        <Theme theme="Madness" themeDesc="Many of Poe’s stories explore the fragile boundary between sanity and madness. His characters often descend into obsession and psychological turmoil, revealing the darker corners of the human mind." />
                        <Theme theme="Time" themeDesc="Clocks and repetition symbolize the pressure of time and guilt. In Poe’s stories, time often becomes a haunting force that drives characters toward their fate." />
                        <Theme theme="Memory" themeDesc="Loss and memory are constant themes in Poe’s writing. Many of his poems reflect longing, grief, and the haunting presence of the past." />
                        <Theme theme="Death" themeDesc="Dark settings, abandoned houses, and fading candles reflect Poe’s fascination with mortality and the unknown beyond life." />
                    </div>
                    <img src={collage3} alt="raven silhoutte with gothic assets" />
                </div>
            </section>
            <section id='quotes'>
                <h4>Echoes of Poe</h4>
                <h5>All that we see or <br /> seem is but a dream <br /> within a dream.</h5>
            </section>
            <Footer />
        </main>
        <article>
            <h5>This website is best experienced <br /> on a larger screen.</h5>
            <p>To explore the dark imagination of <br /> Edgar Allan Poe, please view this <br /> website on desktop.</p>
        </article>
        </>
     );
}
 
export default Home;